<div class="loader-dots-holder" [style.width]='width' [style.height]='height'>
    <div class="loader-dots-preloader {{isWhite ? 'loader-dots-preloader_white' : ''}}"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
</div>